// Eine Kopfzeile (Design-Runde 2): Brotkrumen, Suche (Befehlspalette), auf der Lead-Seite vor/zurück in der Liste,
// rechts die Glocke (Erinnerungen, verpasste Anrufe, Erwähnungen), das Headset-Menü (Absendernummer und
// Audio-Einstellungen) und die Live-Anzeige. Hell/Dunkel steht nur noch in den Einstellungen.
import { Link, useLocation, useNavigate } from "react-router-dom";
import { fokusSetzen, useNachbarn } from "../daten/liste";
import { vorladen } from "../daten/leadCache";
import { useKrumen } from "../daten/seite";
import { useVerbindung } from "../daten/verbindung";
import { T } from "../texte";
import { modTaste } from "../werkzeuge/tasten";
import { Glocke } from "./Glocke";
import { NummernWahlKnopf } from "../telefonie";
import { HeadsetKnopf } from "./HeadsetPruefen";
import { Icon } from "./Icon";
import "./erinnerung.css";

export function Kopfzeile({ onSuche }: { onSuche: () => void }) {
  const krumen = useKrumen();
  const ort = useLocation();
  const navigate = useNavigate();
  const verbindung = useVerbindung();
  const leadId = /^\/lead\/([^/]+)/.exec(ort.pathname)?.[1];
  const n = useNachbarn(leadId ? decodeURIComponent(leadId) : undefined);

  const gehe = (id: string | null) => {
    if (!id) return;
    fokusSetzen(id);
    navigate(`/lead/${encodeURIComponent(id)}`);
  };

  return (
    <header className="kopfzeile">
      <nav className="kopfzeile__krumen" aria-label="Brotkrumen">
        {krumen.map((k, i) => (
          <span key={`${k.label}-${i}`} className="krume">
            {i > 0 ? <Icon name="chevron-rechts" groesse={12} className="krume__trenner" /> : null}
            {k.to && i < krumen.length - 1 ? (
              <Link to={k.to} className="krume__link" title={k.label}>
                {k.label}
              </Link>
            ) : (
              <span className="krume__text" title={k.label}>
                {k.label}
              </span>
            )}
          </span>
        ))}
      </nav>
      <button type="button" className="kopfzeile__suche" onClick={onSuche}>
        <Icon name="suche" groesse={14} />
        <span className="kopfzeile__suchtext" title={T.suche.platzhalter}>{T.suche.platzhalterKurz}</span>
        <kbd className="kopfzeile__taste">{modTaste} K</kbd>
      </button>
      <div className="kopfzeile__rechts">
        {n ? (
          <div className="listennav" aria-label="Liste durcharbeiten">
            <Link to={n.kontext.pfad} className="listennav__zurueck" title={`${T.lead.zurueckZurListe}: ${n.kontext.titel} (Esc)`}>
              <Icon name="pfeil-links" groesse={14} />
            </Link>
            <span className="listennav__stand">
              {n.index + 1} / {n.gesamt}
            </span>
            <button type="button" className="symbolknopf" disabled={!n.vorher} title={`${T.lead.vorheriger} (k)`} aria-label={T.lead.vorheriger} onClick={() => gehe(n.vorher)}>
              <Icon name="chevron-links" groesse={15} />
            </button>
            <button
              type="button"
              className="knopf knopf--klein"
              disabled={!n.nachher}
              title={`${T.lead.naechster} (j)`}
              onMouseEnter={() => n.nachher && vorladen(n.nachher)}
              onClick={() => gehe(n.nachher)}
            >
              {T.lead.naechster}
              <Icon name="chevron-rechts" groesse={13} />
            </button>
          </div>
        ) : null}
        <Glocke />
        <NummernWahlKnopf />
        <HeadsetKnopf />
        <span className={`live live--${verbindung}`} title={verbindung === "verbunden" ? "Echtzeit verbunden" : verbindung === "verbindet" ? "Verbindet …" : "Echtzeit getrennt, verbindet neu …"}>
          <span className="live__punkt" />
          {verbindung === "verbunden" ? null : <span className="live__text">{verbindung === "verbindet" ? "Verbindet" : "Getrennt"}</span>}
        </span>
      </div>
    </header>
  );
}
